<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">配送费管理</span>
      </div>
    </div>

    <div class="content-header">
      <div class="left">
        <Input v-model="searchKey" placeholder="根据配送区域搜索" @on-enter="search">
          <Button slot="append" icon="ios-search" @click="search"></Button>
        </Input>
        <Button style="margin: 2px 0 0 5px" @click="reset">重置</Button>
      </div>
      <div class="right">
        <Button type="primary" @click="handleAdd">新增配送费设置</Button>
        <Button type="primary" style="margin-left: 10px" @click="handleEditBaseFee">修改配送费</Button>
      </div>
    </div>

    <!-- 列表 -->
    <Table :loading="loading" :columns="columns" :data="tableData">
      <template slot-scope="{ row }" slot="region">
        {{ row.region }}
      </template>
      <template slot-scope="{ row }" slot="delivery_fee">
        {{ row.delivery_fee }}元
      </template>
      <template slot-scope="{ row }" slot="free_delivery_amount">
        {{ row.free_delivery_amount }}元
      </template>
      <template slot-scope="{ row }" slot="action">
        <Button type="warning" size="small" @click="handleEdit(row)">编辑</Button>
        <Button
          type="error"
          size="small"
          style="margin-left: 5px"
          @click="handleDelete(row)"
          >删除</Button
        >
      </template>
    </Table>
    <div class="t-right" style="margin-top: 10px">
      <Page
        @on-change="pageChange"
        @on-page-size-change="sizeChange"
        :total="total"
        show-elevator
        show-sizer
        show-total
      />
    </div>

    <!-- 新增/编辑对话框 -->
    <Modal v-model="dialogVisible" :title="dialogTitle" @on-cancel="handleCancel">
      <Form ref="form" :model="form" :rules="rules" :label-width="120">
        <FormItem label="配送区域" prop="region">
          <area-selected
            v-model="selectedRegion"
            :level="3"
            @on-change="handleRegionChange"
          />
        </FormItem>

        <FormItem label="配送费" prop="delivery_fee">
          <InputNumber
            v-model="form.delivery_fee"
            :precision="2"
            :step="1"
            :min="0"
            style="width: 100%"
            @on-change="handleDeliveryFeeChange"
          />
        </FormItem>
        <!--  <FormItem label="免配送费金额" prop="free_delivery_amount">
          <InputNumber
            v-model="form.free_delivery_amount"
            :precision="2"
            :step="0.1"
            :min="0"
            style="width: 100%"
          />
        </FormItem> -->
      </Form>
      <div slot="footer">
        <Button @click="dialogVisible = false">取消</Button>
        <Button type="primary" @click="handleSubmit">确定</Button>
      </div>
    </Modal>

    <!-- 修改配送费对话框 -->
    <Modal v-model="baseFeeDialogVisible" title="修改配送费" @on-cancel="handleBaseFeeCancel">
      <Form ref="baseFeeForm" :model="baseFeeForm" :rules="baseFeeRules" :label-width="120">
        <FormItem label="配送费" prop="base_delivery_fee">
          <InputNumber
            v-model="baseFeeForm.base_delivery_fee"
            :precision="2"
            :step="1"
            :min="0"
            style="width: 100%"
          />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="baseFeeDialogVisible = false">取消</Button>
        <Button type="primary" @click="handleBaseFeeSubmit">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AreaSelected from '@/components/area-selected'

export default {
  name: 'DeliveryFeeList',
  components: {
    AreaSelected
  },
  data () {
    return {
      loading: false,
      tableData: [],
      total: 0,
      searchKey: '',
      dialogVisible: false,
      dialogTitle: '新增配送费设置',
      selectedRegion: [], // 选择的地区数组
      baseFeeDialogVisible: false, // 基础配送费对话框显示状态
      baseFeeForm: {
        base_delivery_fee: 0
      },
      baseFeeRules: {
        base_delivery_fee: [
          {
            required: true,
            type: 'number',
            message: '请输入配送费',
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (value === null || value === undefined || value === '' || value < 0) {
                callback(new Error('请输入配送费'))
              } else {
                callback()
              }
            }
          }
        ]
      },
      columns: [
        {
          title: '配送区域',
          slot: 'region',
          key: 'region'
        },
        {
          title: '配送费',
          slot: 'delivery_fee',
          key: 'delivery_fee'
        },
        /* {
          title: "免配送费金额",
          slot: "free_delivery_amount",
          key: "free_delivery_amount",
        }, */
        {
          title: '操作',
          slot: 'action',
          width: 150,
          align: 'center'
        }
      ],
      form: {
        id: 0,
        region: '',
        min_order_amount: 0,
        delivery_fee: 0,
        free_delivery_amount: 0,
        code: ''
      },
      rules: {
        region: [{ required: true, message: '请选择配送区域', trigger: 'change' }],
        delivery_fee: [
          {
            required: true,
            type: 'number',
            message: '请输入配送费',
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (value === null || value === undefined || value === '' || value <= 0) {
                callback(new Error('请输入配送费'))
              } else {
                callback()
              }
            }
          }
        ]
      }
    }
  },
  created () {
    this.fetchList()
  },
  methods: {
    handleRegionChange (value, selectedData) {
      console.log('selectedData', selectedData)
      // 当地区选择发生变化时，更新form中的region字段
      this.form.region = selectedData.map((item) => item.label).join(',')
      this.form.code = selectedData.map((item) => item.value).join(',')
      // this.form.region = value.join(",");
    },
    async fetchList () {
      this.loading = true
      const res = await this.getDeliveryFeeList()
      this.loading = false
      if (res.status) {
        this.tableData = res.data
        this.total = res.data.length
      } else {
        this.$Message.error(res.msg)
      }
    },
    search () {
      if (!this.searchKey) {
        this.fetchList()
        return
      }
      this.tableData = this.tableData.filter((item) =>
        item.region.toLowerCase().includes(this.searchKey.toLowerCase())
      )
    },
    reset () {
      this.searchKey = ''
      this.fetchList()
    },
    pageChange (page) {
      // 实现分页逻辑
    },
    sizeChange (size) {
      // 实现每页条数变化逻辑
    },
    handleAdd () {
      this.dialogTitle = '新增配送费设置'
      this.form = {
        id: 0,
        region: '',
        min_order_amount: 0,
        delivery_fee: 0,
        free_delivery_amount: 0,
        code: ''
      }
      this.selectedRegion = [] // 重置选择的地区
      this.$nextTick(() => {
        this.dialogVisible = true
      })
    },
    handleEdit (row) {
      this.dialogTitle = '编辑配送费设置'
      this.form = { ...row }
      // 将已保存的region字符串转换为数组格式
      this.selectedRegion = row.code.split(',')

      this.dialogVisible = true
    },
    async handleDelete (row) {
      try {
        await this.$Modal.confirm({
          title: '提示',
          content: '确认删除该配送费设置?',
          onOk: async () => {
            const res = await this.deleteDeliveryFee({ id: row.id })
            if (res.status) {
              this.$Message.success('删除成功')
              this.fetchList()
            } else {
              this.$Message.error(res.msg)
            }
          }
        })
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除配送费设置失败:', error)
          this.$Message.error('删除失败，请稍后重试')
        }
      }
    },
    async handleSubmit () {
      try {
        const check = await this.$refs.form.validate()
        if (!check) {
          return
        }
        console.log('check', check)
        const res = await this.saveDeliveryFee(this.form)
        if (res.status) {
          this.$Message.success('保存成功')
          this.dialogVisible = false
          this.fetchList()
        } else {
          this.$Message.error(res.msg)
        }
      } catch (error) {
        if (error !== false) {
          console.error('保存配送费设置失败:', error)
          this.$Message.error('保存失败，请稍后重试')
        }
      }
    },
    handleCancel () {
      this.$refs.form.resetFields()
      this.selectedRegion = []
      this.dialogVisible = false
    },
    handleDeliveryFeeChange (value) {
      this.form.delivery_fee = value
      this.$refs.form.validateField('delivery_fee')
    },
    handleEditBaseFee () {
      this.baseFeeForm.base_delivery_fee = this.agent.base_delivery_fee || 0
      this.baseFeeDialogVisible = true
    },
    handleBaseFeeCancel () {
      this.baseFeeDialogVisible = false
      this.$refs.baseFeeForm.resetFields()
    },
    async handleBaseFeeSubmit () {
      try {
        const check = await this.$refs.baseFeeForm.validate()
        if (!check) {
          return
        }
        const res = await this.SaveAgentBaseDeliverFee({
          base_delivery_fee: this.baseFeeForm.base_delivery_fee
        })
        if (res.status) {
          this.$Message.success('保存成功')
          this.baseFeeDialogVisible = false
          // 更新本地数据
          this.agent.base_delivery_fee = this.baseFeeForm.base_delivery_fee
        } else {
          this.$Message.error(res.msg)
        }
      } catch (error) {
        if (error !== false) {
          console.error('保存配送费失败:', error)
          this.$Message.error('保存失败，请稍后重试')
        }
      }
    },
    ...mapActions([
      'getDeliveryFeeList',
      'saveDeliveryFee',
      'deleteDeliveryFee',
      'getUserInfo',
      'SaveAgentBaseDeliverFee'
    ])
  },
  computed: mapGetters({
    agent: 'agent'
  })
}
</script>

<style lang="less" scoped>
.content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;

  .left {
    display: flex;
    align-items: center;

    .title {
      font-size: 16px;
      font-weight: 500;
    }
  }

  .right {
    display: flex;
    align-items: center;
  }
}

.t-right {
  text-align: right;
  padding: 10px 0;
}

/deep/ .ivu-input-number {
  width: 100%;
}
</style>
